import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';

export default class ClientCommands {
    constructor(client, messageBox) {
        this.client = client;
        this.messageBox = messageBox;
        this.GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';
        //this.graphTemplateID = "_FFFFFFFFFFFFFF00001747847974849561_";

        let params = {
            componentId : this.GRAPHSERVER,
            command : "GetGraphInfo",
            data : {"Context":this.messageBox.CurrentContext},
            Type : 'BotApi'
        }
        let graphTemplateIds = [];
        window.top.BotServices.callComponent(params, (err, result) => {
            //console.log('clientcommands-constructor', 'GetGraphInfo-result:', result);
            result.forEach((e) => {
                graphTemplateIds.push(e.Node)
            });
            //console.log('clientcommands-constructor', 'graphTemplateIds:', graphTemplateIds);
            this.graphTemplateID = graphTemplateIds[0];
        });
    }

    init() {
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'pullPE' }, this.pullPE.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'openChildPanel' }, this.openChildPanel.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'inviteToMeeting' }, this.inviteToMeeting.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'callBotConnect' }, this.callBotConnect.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'loginSimplia' }, this.loginSimplia.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'assignObjectToStage' }, this.assignObjectToStage.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'setGraphNode' }, this.setGraphNode.bind(this));
        window.BotServices.addClientCommand({Client : this.client.Client, Command : 'setGraphEdge' }, this.setGraphEdge.bind(this));
    }

    async setGraphEdge(data, callback) {
        console.log('setGraphEdge', 'data:', data);
        async.waterfall([
            (callback)=> {
                window.top.BotServices.callComponent({
                    componentId : this.GRAPHSERVER,
                    command : "GetGraph",
                    data : {"Context":this.messageBox.CurrentContext,"GraphTemplate":this.graphTemplateID},
                    Type : 'BotApi'
                }, callback);
            },
            (results, callback) => {
                console.log('setGraphEdge', 'GetGraph-results:', results);
                let nodes = results.filter((e)=> {
                    return e._source.GraphMetaType === 'Node';
                });
                console.log('setGraphEdge', 'nodes:', nodes);
                let sourceNode = nodes.find(e => (e._source.Label === data.source) ),
                    targetNode = nodes.find(e => (e._source.Label === data.target));

                console.log('setGraphEdge', 'sourceNodeId:', sourceNode, ' - targetNodeId:', targetNode);
                let edge = {
                    "type": "oxygenedge",
                    "markerEnd": {
                        "type": "arrowclosed"
                    },
                    "pathOptions": {
                        "offset": 5
                    },
                    "source": sourceNode._id,
                    "sourceHandle": null,
                    "target": targetNode._id,
                    "targetHandle": null,
                    "id": oxygenUtil.getGUID(),
                    "label": data.edgeLabel,
                    "data": {
                        "grantItem": this.messageBox.CurrentContext.grantItem
                    },
                    "selected": true,
                    "style": {
                        "stroke": "green"
                    }
                }

                let params = {
                    componentId : this.GRAPHSERVER,
                    command : "AddEdge",
                    data : {
                        "Edge":edge,
                        "FormData":data.FormData,
                        "GraphTemplateID": this.graphTemplateID,
                        "NodeTemplateID":"_FFFFFFFFFFFFFF00001684860693317004_",
                        "EdgeTemplateID":"_FFFFFFFFFFFFFF00001684860693317022_"},
                    Type : 'BotApi'
                }

                window.top.BotServices.callComponent(params, (err, result) => {
                    if(result) {
                        console.log("AddEdge Result : ",result);
                        //edge.data.updateEdge(result);
                    }
                    callback();
                });
            }
        ], (error)=>{
            if(error) {
                console.log('setGraphEdge', 'Error:', error);
            }
        })

    }

    async setGraphNode(data, callback) {
        console.log('setGraphNode', 'data:', data);
        //TODO: For now, putting a default template id; the list of templates should be
        //TODO: fetched from context using 'GetGraphInfo' API and then letting user decide

        /*
            Sample FormData
                Action: "Action"
                Name: "Interested"
                Results: []
                Role: "admin"
                editFlag: false
         */

        /*
            Sample Node
{
            "id": "_FF07508219919317474182105931715115_",
            "type": "OxygenNode",
            "position": {
                "x": 351.6231952662722,
                "y": 261.02475739644973
            },
            "data": {
                "label": "Interested",
                "grantItem": {},
                "state": "default",
                "graphTemplateID": "_FFFFFFFFFFFFFF00001747417537151119_",
                "behaviour": {
                    "Name": "Interested",
                    "Role": "admin",
                    "Action": "Action",
                    "Results": [],
                    "editFlag": false
                }
            },
            "width": 88,
            "height": 56,
            "selected": true,
            "dragging": false,
            "positionAbsolute": {
                "x": 351.6231952662722,
                "y": 261.02475739644973
            }
        }
         */

        let node = {
            "id": data.nodeId || oxygenUtil.getGUID(),
            "type": "OxygenNode",
            "position": {
                "x": 351.6231952662722,
                "y": 261.02475739644973
            },
            "data": {
                "label": data.FormData.Name,
                "grantItem": this.messageBox.CurrentContext.grantItem,
                "state": "default",
                "graphTemplateID": this.graphTemplateID,
                "behaviour": data.FormData
            },
            "width": 88,
            "height": 56,
            "selected": true,
            "dragging": false,
            "positionAbsolute": {
                "x": 351.6231952662722,
                "y": 261.02475739644973
            }
        }


        let params = {
            componentId : this.GRAPHSERVER,
            command : data.FormData.editFlag ? "EditNode" : "AddNode",
            data : {
                "Node":node,
                "FormData": data.FormData,
                "GraphTemplateID": this.graphTemplateID,
                "NodeTemplateID":"_FFFFFFFFFFFFFF00001684860693317004_",
                "EdgeTemplateID":"_FFFFFFFFFFFFFF00001684860693317022_"
            },
            Type : 'BotApi'
        }
        console.log('setGraphNode', "AddNode params:",params);

        window.top.BotServices.callComponent(params, (err, result) => {
            if(result) {
                console.log('setGraphNode', "===result AddNode===:",result);
                //node.data.updateNode(result);
            }
            callback();
        });

    }

    async pullPE(data, callback) {
        console.log('ClientCommands', ' - pullPE', ' - data:', data);
        await window.oxygenUtil.pullPE(
            {
                ByClientID : this.client.Client,
                InitialContext : Object.assign({
                    ByClientID : this.client.Client

                }, data.InitialContext || {}),
                OpenPE : data.GrantPE
            },
            data,
            async (err) => {
                await this.messageBox.$nextTick();
                await this.messageBox.$nextTick();
                if(data.openInbox) {
                    let client = window.botStore.clients.reverse().find(e => {
                        return (data.GrantPE === oxygenUtil.createSimpleOES([e.ClientLeftRole, e.ClientLeft, e.ClientRightRole, e.ClientRight]));
                    });
                    //console.log('setOxygenLinkClickHandler-callback', 'client:', client);
                    if (client) {

                        window.BotServices.openChildPanel({ClientID: client.Client, DisplayName: 'Inbox',
                            Termination: {
                                MediaType : 'WebComponent',
                                URL: '/simplia/dist/builds/inbox-wc/app.js',
                                Template: 'oxygen-inbox',
                                dataset: data.inboxDataset || {}
                            }
                        }, callback);
                    }
                }
                else {
                    callback();
                }
            }
        );

        //await oxygenUtil.addRecent(data.GrantPE, data.GrantLeftDN, data.GrantRightDN);

    }

    openChildPanel(data, callback) {
        console.log('openChildPanel', 'data:', data, ' - callback:', callback);
        let panelName = {
            'RelatedLinks': () => {
                this.messageBox.showChildViewport('showAttachments');
            },
            'AccountInfo': () => {
                this.messageBox.showChildViewport('showAccountInfo');
            },
            'Files': () => {
                this.messageBox.showChildViewport('showFiles');
            }
        }
        data && data.panelName && panelName[data.panelName] && panelName[data.panelName]();
        callback();
    }

    loginSimplia(data, callback) {
        console.log('loginSimplia', 'data:', data);
        callback();
    }

    inviteToMeeting(data, callback) {
        let params = {
            ClientID: this.client.Client,
            to: {
                tope: data.tope || [],
                componentid: data.componentid || [],
                email: data.email || [],
                phone: data.phone || []
            },
            thread: this.messageBox.componentData.asComponent.Node,
            subject: this.messageBox.componentData.atComponent.Node,
            message: data.inviteMessage || '',
            bype: this.messageBox.envelopeByPE,
            schedule: {
                start: '',
                end: ''
            },
            mode: data.mode || 'invite'
        }
        window.BotServices.callManagerExec(params, () => {
            callback();
        });
    }

    async callBotConnect(data, callback) {
        console.log('callBotConnect', 'data:', data);
        await window.oxygenUtil.doBotConnect(this.client.Client, data.toPE);
        callback();
    }

    async assignObjectToStage(data, callback) {
        console.log('assignObjectToStage', 'data:', data);
        let rowComponent = await oxygenUtil.getComponentByDisplayName(data.displayName);
        await async.waterfall([
            (callback) => {
                let PostParams = {
                    componentId: '_FFFFFFFFFFFFFF00001713960477110008_',
                    command: "GetDataPE",
                    data: {Context : this.messageBox.CurrentContext, RowData : {'Primary Key': rowComponent.Node}},
                    Type: 'BotApi'
                };
                window.top.BotServices.callComponent(PostParams, callback);
            },
            async (result) => {
                console.log('assignObjectToStage', 'result:', result);
                if(result && result.GrantItem) {
                    await window.oxygenUtil.pullPE(

                        {
                            ByClientID : this.client.Client,
                            InitialContext : {
                                ByClientID : this.client.Client
                            },
                            OpenPE : result.GrantItem.GrantPE
                        },
                        result.GrantItem,
                        async () => {
                            console.log('assignObjectToStage', 'pullPE-callback called');
                            await this.messageBox.$nextTick();
                            await this.messageBox.$nextTick();
                            await this.messageBox.$nextTick();
                            let client, count = 0;
                            let intervalId = setInterval( async()=>{

                                client = window.botStore.clients.reverse().find(e => {
                                    return (result.GrantItem.GrantPE === oxygenUtil.createSimpleOES([e.ClientLeftRole, e.ClientLeft, e.ClientRightRole, e.ClientRight]));
                                });

                                console.log('assignObjectToStage-callback', 'client:', client, ' - id:', client.Client);
                                let viewport;
                                if(client || (count > 10)) {
                                    clearInterval(intervalId);
                                    if(client) {
                                        count = 0;
                                        intervalId = setInterval(async ()=>{
                                            viewport = window.devStore.viewPorts.find(e => {
                                                return e.ClientID === client.Client;
                                            });

                                            console.log('assignObjectToStage-callback', 'viewport:', viewport, ' - id:', viewport.viewportID);
                                            if(viewport || (count > 10)) {
                                                clearInterval(intervalId);
                                                if(viewport) {
                                                    console.log('assignObjectToStage-callback', 'calling toggleDeskMode:', viewport.viewportID);
                                                    count = 0;
                                                    intervalId = setInterval(async ()=>{
                                                        if(window.top.clientsAPI[client.Client] || (count > 10)) {
                                                            clearInterval(intervalId);
                                                            if(window.top.clientsAPI[client.Client]) {
                                                                await window.top.oxygenUtil.callViewportComponentFnWithReturn(viewport.viewportID, 'viewport-header', 'toggleRibbon', []);
                                                                await window.top.oxygenUtil.callViewportComponentFnWithReturn(viewport.viewportID, 'viewport-header', 'toggleDeskMode', [true]);

                                                                let rules = window.top.devStore.behaviours[client.ClientLeft+client.ClientRight].Rules;
                                                                let behaviour = rules.find((e)=>{
                                                                    return e.Result.toLowerCase() === data.action.toLowerCase();
                                                                });
                                                                if(behaviour) {

                                                                    let currentContext = JSON.parse(client.CurrentContext);
                                                                    let params = {
                                                                        ClientID : client.Client,
                                                                        Type : "Result",
                                                                        Data : {"Node":behaviour.Node,"Behaviour":{"Role":behaviour.Role,"Action":behaviour.Action,"Result":behaviour.Role+':'+behaviour.Action+'/'+behaviour.Result,"Cycle":behaviour.Cycle,"Qualifier":behaviour.Qualifier},"FormData":{"Name":behaviour.behaviourRowObj,"Results":behaviour.behaviourRowObj},"Context":currentContext,"GraphTemplateID":behaviour.Node.GraphTemplateID,"GraphTemplate":behaviour.Node.GraphTemplateID},
                                                                    }
                                                                    //console.log("Exec Result params",params);

                                                                    window.top.BotServices.ExecDesk(params, async (err, result) => {
                                                                        if(result) {
                                                                            console.log("===result Exec Result===",result);
                                                                            let assigneeComponent = await oxygenUtil.getComponentByDisplayName(data.assignee);
                                                                            console.log('assignObjectToStage-callback', 'assigneeComponent:', assigneeComponent);
                                                                            let rows = await oxygenUtil.runDBQuery(
                                                                                `select * from OxygenDatabase.Grants where GrantRightID = ? and GrantRightR = ? and GrantLeftID =  ? and GrantType = ? `,
                                                                                [this.client.ClientRight,  data.assigneeRole, assigneeComponent.Node, 'Grant']
                                                                            );
                                                                            console.log('assignObjectToStage-callback', 'rows:', rows);
                                                                            let AssignRowParams = {
                                                                                componentId: '_FFFFFFFFFFFFFF00001713960477110008_',
                                                                                command: "AssignRow",
                                                                                data: { "Context": this.CurrentContext, "Contact": rows[0], "ID":client.ClientRight},
                                                                                Type: 'BotApi'
                                                                            }
                                                                            window.top.BotServices.callComponent(AssignRowParams, (err, result) => {
                                                                                console.log("AssignRow Got : ", result);
                                                                                if(result) {
                                                                                    console.log("AssignRow Got Result: ", result);
                                                                                } else {
                                                                                    console.log("AssignRow Got Error: ", err);
                                                                                    /*webix.alert({
                                                                                      title: "Error!",
                                                                                      ok: "Close",
                                                                                      text: "Assign Row Error :"+ JSON.stringify(err) +".  Please try again."
                                                                                    });*/
                                                                                }
                                                                            });
                                                                            if(result.State == 'Idle') {
                                                                            }
                                                                        } else {
                                                                            console.log("===result Exec Result Error===",err);
                                                                        }
                                                                    });
                                                                }
                                                            }
                                                        }
                                                        count++;
                                                    }, 200);
                                                }
                                            }
                                            count++;
                                        }, 200);
                                    }
                                }
                            }, 200);
                        }

                    )
                }
            }
        ]);
        callback();
    }
}

